import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import Dropdown from "react-bootstrap/Dropdown";
import type ExemptionsViewModel from "viewModels/callCenter/search/exemptions/exemptionsViewModel";
import type ExemptionResponse from "entities/exemptionResponse";
import { camelCase } from "lodash";
import Tooltip from "@edaz/edazkit/Tooltip";
export interface ExemptionActionMenuProps {
  vm: ExemptionsViewModel;
  exemption: ExemptionResponse;
}

const ExemptionActionMenu: FunctionComponent<ExemptionActionMenuProps> = observer((props: ExemptionActionMenuProps) => {
  const { vm, exemption } = props;

  return (
    <Dropdown drop="left">
      <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
        ⋮
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight={true}>
        {vm.actions.map(action => {
          const permittedAction = vm.permittedActions(exemption, action);
          let content: React.ReactNode = vm.translate(`actions.${camelCase(action)}.name`);
          if (!permittedAction.isAllowed && permittedAction?.rejectionReason) {
            content = (
              <Tooltip
                id={`exemption-${exemption.exemptionId}-${action}`}
                tooltip={vm.translate(`rejectionReason.${action}.${permittedAction.rejectionReason}`)}>
                <span>{content}</span>
              </Tooltip>
            );
          }
          if (permittedAction.isAllowed) {
            return (
              <Dropdown.Item
                key={action}
                disabled={!permittedAction.isAllowed}
                onClick={() => vm.handleDropdownAction(exemption, action)}
                style={{ pointerEvents: "auto" }}>
                {content}
              </Dropdown.Item>
            );
          }
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default ExemptionActionMenu;
